module.exports = {
  apiHost: "https://api.savana.sensoreal.com.au",
  assetsHost: "https://assets.savana.sensoreal.com.au",
  contact: {
    address:
      "23 Brightvale Bvd<br>Wyndham Vale VIC 3024 415 Princes HwyOfficer VIC 3809",
    email: "elan@avid.com.au",
    phone: "1300 723 452",
    website: "https://savana.avid.com.au",
  },
  formTemplate: "default",
  header: {
    logo: "https://assets.elan.sensoreal.com.au/misc/AVID_White_72dpi.png",
    text: {
      en: "Your Savana Selections",
      ar: "",
    },
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  links: {
    instagram: "https://www.instagram.com/avid_together/",
    facebook: "https://www.facebook.com/savana.wyndhamvale",
    linkedin: "",
    privacy: "https://avid.com.au/privacy-policy",
    twitter: "",
    youtube: "",
  },
  style: {
    primaryColor: "#1b2a38",
    textColor: "#fff",
  },
};
